// extracted by mini-css-extract-plugin
module.exports = {"nameCell":"table-row_nameCell__3A4vA","hideOnMobile":"table-row_hideOnMobile__3J_xf"};